var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BreadcrumbList',{attrs:{"items":_vm.breadcrumbs}}),_c('FlexibleContentArea',[_c('PageMain',[_c('div',{staticClass:"error-title"},[_vm._v("404 NOT FOUND")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }